import {
  useMemo
} from 'react';

import {
  HereLayer
} from 'common/utils/MapMarker/types';
import { Station } from 'dataSources/Typicode/stations';
import { OnMarkerClick } from 'components/Map/hooks/useOnStationMarkerClick';

import {
  getIcon,
  getMarkerType
} from '../utils';

import { useSelectedStationCode } from 'store/features/station';
import { useHandlerHereStationMarkersHover } from 'components/Map/hooks/useInitHandlerStationMarkersHover';

import { STATION_ICONS_Z_COORDS } from 'features/stations';
import { useIsStationSelected } from 'entities/stations';


export const getStationCoordinates = (
  { selectedStationCode }: { selectedStationCode?: Station['code'] }
) => (
  { data }: { data: Station | { coordinates: { latitude: number; longitude: number; } } },
) => {
  let altitude = 0;

  if ('code' in data) {
    if (selectedStationCode === data.code) {
      altitude = STATION_ICONS_Z_COORDS.cluster - 1
    } else {
      altitude = STATION_ICONS_Z_COORDS[getMarkerType({ data })['markerType'] as keyof typeof STATION_ICONS_Z_COORDS] || 1;
    }
  } else {
    altitude = STATION_ICONS_Z_COORDS.cluster
  }

  return {
    latitude: data.coordinates.latitude,
    longitude: data.coordinates.longitude,
    altitude
  };
}

interface StationMarkersLayerProps {
  data: Station[];
}

interface StationMarkersLayerHadlers {
  onMarkerClick?: OnMarkerClick;
}

export const useStationMarkersLayer = (
  { data }: StationMarkersLayerProps,
  { onMarkerClick }: StationMarkersLayerHadlers
) => {
  const selectedStationCode = useSelectedStationCode();
  const handlerHereStationMarkersHover = useHandlerHereStationMarkersHover();
  const isStationSelected = useIsStationSelected();

  const dataShow = useMemo(() => (
    data.filter((station) => !isStationSelected(station))
  ), [data, isStationSelected]);

  const stationMarkersLayer = useMemo((): HereLayer => ({
    data: dataShow,
    name: 'stations',
    type: 'cluster',
    getCoordinates: getStationCoordinates({ selectedStationCode }),
    getIcon: (getIconProps) => getIcon({ ...getIconProps, selectedStation: selectedStationCode }),
    onClick: ({ data }: any) => {
      if (onMarkerClick && data) {
        onMarkerClick(data);
      }
    },
    onPointermove: (event) => {
      handlerHereStationMarkersHover(event);
    },
    onDragStart: (event) => {
      handlerHereStationMarkersHover(event);
    }
  }), [
    dataShow,
    selectedStationCode,
    onMarkerClick,
    handlerHereStationMarkersHover
  ]);

  return stationMarkersLayer;
};
